import { all, call, put, takeLatest } from 'redux-saga/effects'
import type { ApiError } from '@pbt/pbt-ui-components'

import * as API from '~/api'

import {
  FETCH_INVENTORY_ITEM_TRACKING_FOR_VARIATION,
  FETCH_MORE_INVENTORY_ITEM_TRACKING_FOR_VACCINE,
  FETCH_MORE_INVENTORY_ITEM_TRACKING_FOR_VACCINE_WITH_VARIATION,
  FETCH_MORE_INVENTORY_ITEM_TRACKING_FOR_VARIATION,
  type fetchInventoryItemTrackingForVariation,
  fetchInventoryItemTrackingForVariationFailure,
  fetchInventoryItemTrackingForVariationSuccess,
  type fetchMoreInventoryItemTrackingForVaccine,
  fetchMoreInventoryItemTrackingForVaccineFailure,
  fetchMoreInventoryItemTrackingForVaccineSuccess,
  type fetchMoreInventoryItemTrackingForVaccineWithVariation,
  fetchMoreInventoryItemTrackingForVaccineWithVariationFailure,
  fetchMoreInventoryItemTrackingForVaccineWithVariationSuccess,
  type fetchMoreInventoryItemTrackingForVariation,
  fetchMoreInventoryItemTrackingForVariationFailure,
  fetchMoreInventoryItemTrackingForVariationSuccess,
} from '../duck/inventoryItemTracking'
import requestAPI from './utils/requestAPI'
import updateEntities from './utils/updateEntities'

export function* fetchInventoryItemTrackingForVariationSaga({
  variationId,
  from,
  to,
}: ReturnType<typeof fetchInventoryItemTrackingForVariation>) {
  try {
    const {
      result: { data: list, totalCount },
      entities,
    } = yield requestAPI(
      API.fetchInventoryItemTrackingForVariation,
      variationId,
      from,
      to,
    )

    yield call(updateEntities, entities)
    yield put(
      fetchInventoryItemTrackingForVariationSuccess(list, from, totalCount),
    )
  } catch (error) {
    yield put(fetchInventoryItemTrackingForVariationFailure(error as ApiError))
  }
}

export function* fetchMoreInventoryItemTrackingForVariationSaga({
  variationId,
  from,
  to,
}: ReturnType<typeof fetchMoreInventoryItemTrackingForVariation>) {
  try {
    const {
      result: { data: list, totalCount },
      entities,
    } = yield requestAPI(
      API.fetchInventoryItemTrackingForVariation,
      variationId,
      from,
      to,
    )
    yield call(updateEntities, entities)
    yield put(
      fetchMoreInventoryItemTrackingForVariationSuccess(list, from, totalCount),
    )
  } catch (error) {
    yield put(
      fetchMoreInventoryItemTrackingForVariationFailure(error as ApiError),
    )
  }
}

export function* fetchMoreInventoryItemTrackingForVaccineSaga({
  vaccinationId,
  from,
  to,
}: ReturnType<typeof fetchMoreInventoryItemTrackingForVaccine>) {
  try {
    const {
      result: { data: list, totalCount },
      entities,
    } = yield requestAPI(
      API.fetchInventoryItemTrackingForVaccine,
      vaccinationId,
      from,
      to,
    )
    yield call(updateEntities, entities)
    yield put(
      fetchMoreInventoryItemTrackingForVaccineSuccess(list, from, totalCount),
    )
  } catch (error) {
    yield put(
      fetchMoreInventoryItemTrackingForVaccineFailure(error as ApiError),
    )
  }
}

export function* fetchMoreInventoryItemTrackingForVaccineWithVariationSaga({
  vaccinationId,
  from,
  to,
  includeExpiredItems,
}: ReturnType<typeof fetchMoreInventoryItemTrackingForVaccineWithVariation>) {
  try {
    const {
      result: { data: list, totalCount },
      entities,
    } = yield requestAPI(
      API.fetchInventoryItemTrackingForVaccineWithVariation,
      vaccinationId,
      from,
      to,
      includeExpiredItems,
    )
    yield call(updateEntities, entities)
    yield put(
      fetchMoreInventoryItemTrackingForVaccineWithVariationSuccess(
        list,
        from,
        totalCount,
      ),
    )
  } catch (error) {
    yield put(
      fetchMoreInventoryItemTrackingForVaccineWithVariationFailure(
        error as ApiError,
      ),
    )
  }
}

export default function* inventoryItemTrackingSaga() {
  yield all([
    takeLatest(
      FETCH_INVENTORY_ITEM_TRACKING_FOR_VARIATION,
      fetchInventoryItemTrackingForVariationSaga,
    ),
    takeLatest(
      FETCH_MORE_INVENTORY_ITEM_TRACKING_FOR_VARIATION,
      fetchMoreInventoryItemTrackingForVariationSaga,
    ),
    takeLatest(
      FETCH_MORE_INVENTORY_ITEM_TRACKING_FOR_VACCINE,
      fetchMoreInventoryItemTrackingForVaccineSaga,
    ),
    takeLatest(
      FETCH_MORE_INVENTORY_ITEM_TRACKING_FOR_VACCINE_WITH_VARIATION,
      fetchMoreInventoryItemTrackingForVaccineWithVariationSaga,
    ),
  ])
}
